module.exports = __webpack_public_path__ + "img/K41-portugal.823e147f.png";